<template>
  <div id="navBox">
    <div class="logo-box">百科数据资源库</div>
    <p hidden class="topIndex">{{ topIndex }}</p>
    <ul class="navList">
      <!-- <li v-for="item in data" :key="item.link" @click="getChild">
        <a :href="item.link">{{ item.name }}</a>
      </li> -->
      <li
        v-for="item in data"
        :key="item.permName"
        @click="getChild"
        :class="item.permName"
      >
        <a :href="item.url">{{ item.permDesc }}</a>
      </li>
    </ul>
    <div class="userMes">
      <a
        href="/Home"
        target="_blank"
        style="display: inline-block; margin-right: 10px; text-decoration: none"
        >发布前台<i style="margin-left: 5px" class="el-icon-monitor"></i
      ></a>
      <a
        href="/countPage"
        style="display: inline-block; margin-right: 10px; text-decoration: none"
        target="_blank"
        >统计<i class="el-icon-s-data"></i
      ></a>
      <!-- <span>当前登录：</span>
      <span class="username-button" id="username">郭德纲</span> -->
       <!-- 已登录显示用户+退出 -->
      <template v-if="isLogin">
        <span>当前登录：</span>
        <span class="username-button" id="username">{{ userName }}</span>
        <button class="logout-btn" @click="logout">退出登录</button>
      </template>
      <!-- 未登录显示登录按钮 -->
      <template v-else>
        <button class="login-btn" @click="goLogin">登录</button>
      </template>

    </div>
  </div>
</template>

<script>
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data() {
    return {
      data: [],
      isLogin: false, // 是否登录
      userName: "", // 登录用户名
    };
  },
  props: {
    topIndex: String,
  },
  mounted() {
    // 初始化登录状态
    this.getUserInfo();

    // 统一验证token
    var that = this;
    if (this.$route.query.key) {
      $.ajax({
        url: "/zyk/api/check/token",
        type: "GET",
        dataType: "json",
        data: { token: this.$route.query.key },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (res) {
          cookies.set("token", res.obj.token);
          cookies.set("userName", res.obj.user.realName);
          that.data = res.obj.catalog; // 修复原bug：不需要JSON.stringify，v-for需要数组
          localStorage.setItem("catalog", JSON.stringify(res.obj.catalog));
          that.getUserInfo(); // 刷新登录信息
        },
      });
    } else {
      // 本地读取菜单
      const catalog = localStorage.getItem("catalog");
      if (catalog) {
        this.data = JSON.parse(catalog);
      }
    }

    // 导航激活逻辑
    setTimeout(function () {
      const gettopIndex = $(".topIndex").text();
      $.each($(".navList li"), function (index, obj) {
        var divClass = $(obj).prop("class");
        if (divClass == gettopIndex) {
          $(obj).addClass("navActive");
          $(obj).siblings().removeClass("navActive");
        }
      });
    }, 300);
  },
  methods: {
    getChild() {
      console.log(this.index);
    },
    // 跳转登录页（根据你项目登录路由自行修改地址）
    goLogin() {
      // 示例登录地址，自行替换成你的登录页面
      window.location.href = "/login";
    },
        // 获取本地登录信息
    getUserInfo() {
      const token = cookies.get("token");
      const name = cookies.get("userName");
      if (token && name) {
        this.isLogin = true;
        this.userName = name;
        $("#username").text(name);
      } else {
        this.isLogin = false;
        this.userName = "";
      }
    },
    logout() {
      // 仅清空本地存储，不请求接口
      cookies.remove("token");
      cookies.remove("userName");
      localStorage.removeItem("catalog");
      this.isLogin = false;
      this.userName = "";
      window.location.href = "/login";
    }
  },
};
</script>

<style>
/* 导航页css */
#navBox {
  position: fixed;
  width: 100vw;
  height: 90px;
  overflow: hidden;
  top: 0;
  background-color: #fff;
  z-index: 20;
}

#navBox::after {
  content: "";
  display: inline-block;
  clear: both;
}

#navBox .logo-box {
  float: left;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  width: 170px;
  height: 83%;
  line-height: 74px;
  text-align: center;
  display: inline-block;
  background: #36474f;
}

#navBox .navList {
  box-shadow: 1px 7px 7px -4px #cdcdcd;
}

#navBox .navList li {
  line-height: 74px;
  display: inline-block;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 700;
  padding: 0 30px;
  color: #4c5d65;
}

#navBox .navList li.navActive a,
#navBox .navList li:hover a {
  color: #50b58d;
}

#navBox .userMes {
  position: absolute;
  right: 0;
  top: 0;
  height: 74px;
  font-size: 14px;
  margin-right: 20px;
}

#navBox .userMes span {
  vertical-align: middle;
  line-height: 74px;
}

#navBox .userMes span + span {
  padding-right: 20px;
}

#navBox .userMes a {
  line-height: 74px;
  text-decoration: underline;
  padding-right: 10px;
}
/* 登录退出按钮样式 */
.login-btn,
.logout-btn {
  margin-left: 12px;
  padding: 4px 12px;
  height: 30px;
  line-height: 22px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  vertical-align: middle;
}
.login-btn {
  background: #50b58d;
  color: #fff;
}
.logout-btn {
  background: #eee;
  color: #333;
}
.login-btn:hover {
  background: #429e7a;
}
.logout-btn:hover {
  background: #ddd;
}
</style>
